import { render, staticRenderFns } from "./route.vue?vue&type=template&id=0042de72&scoped=true"
import script from "./route.vue?vue&type=script&lang=js"
export * from "./route.vue?vue&type=script&lang=js"
import style0 from "./route.vue?vue&type=style&index=0&id=0042de72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0042de72",
  null
  
)

export default component.exports